import React, { useState } from "react"
import { Image } from "antd"

import { useTranslation } from "react-i18next"
import { Driver } from "@/types/drivers.types"
import { isEmpty } from "lodash"
import { DateTime } from "luxon"
import { EU_DATE_TIME_FORMAT } from "@/utils/datetime"

interface DriverAttachmentsModalProps {
  button: React.ReactElement
  driver?: Driver
}
// @ts-ignore
const DriverAttachmentsModal: React.FC<DriverAttachmentsModalProps> = ({ button, driver }) => {
  const { t } = useTranslation()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const attachments = driver?.attachments || []

  if (isEmpty(attachments)) {
    return
  }

  return (
    <>
      {React.cloneElement(button, { onClick: () => setIsModalVisible(true) })}
      <div style={{ display: "none" }}>
        <Image.PreviewGroup
          preview={{
            className: "details-pod-preview",
            visible: isModalVisible,
            maskClosable: false,
            maskStyle: { backgroundColor: "rgba(0, 0, 0, 0.9)" },
            onVisibleChange: (vis) => setIsModalVisible(vis),
            imageRender: (node, rest) => {
              const expiresAt =
                typeof attachments?.[rest?.current]?.expiresAt === "number"
                  ? DateTime.fromMillis(attachments?.[rest?.current]?.expiresAt!)
                  : null
              return (
                <div className="flex flex-col h-full gap-y-6 items-center justify-center text-gray-100">
                  <p className="text-lg whitespace-pre-line max-w-[400px] ">
                    {attachments?.[rest?.current]?.name}
                  </p>
                  <div className="flex flex-col gap-y-2">
                    {node}
                    {expiresAt?.isValid && (
                      <p className="text-white">
                        {`${t("common.expiresAt")} ${expiresAt.toFormat(EU_DATE_TIME_FORMAT)}`}{" "}
                      </p>
                    )}
                  </div>
                </div>
              )
            },
          }}
        >
          {driver?.attachments?.map((attachment) => (
            <Image key={attachment.url} src={attachment.url} title={attachment.name} />
          ))}
        </Image.PreviewGroup>
      </div>
    </>
  )
}

export default DriverAttachmentsModal
